export default __webpack_public_path__ + "323eb5070f6d88dd49aa0ed864785b38.svg";